import { render, staticRenderFns } from "./PqrFormNombre.vue?vue&type=template&id=948f03d4"
import script from "./PqrFormNombre.vue?vue&type=script&lang=js"
export * from "./PqrFormNombre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports